/* GLP landing page: customer video tiles play in place on tap, with no
   native control bar. Progressive enhancement: the markup ships with native
   controls; this script removes them, toggles play / pause on the tile, and
   shows the page's own play glyph only while the video is paused. One tile
   plays at a time. Sound stays on (the shopper asked for it by tapping). */
(function () {
  'use strict';
  if (window.KP_GLP_VIDEO_LOADED) return;
  window.KP_GLP_VIDEO_LOADED = true;

  function tiles() {
    return Array.prototype.slice.call(document.querySelectorAll('.kp-glp-reviews__tile--video'));
  }

  function pauseOthers(current) {
    tiles().forEach(function (t) {
      var v = t.querySelector('video');
      if (v && v !== current && !v.paused) v.pause();
    });
  }

  function label(tile, playing) {
    tile.setAttribute('aria-label', playing ? 'Pause customer video' : 'Play customer video');
  }

  function enhance(tile) {
    if (tile.getAttribute('data-kp-video-bound') === '1') return;
    var video = tile.querySelector('video');
    if (!video) return;
    tile.setAttribute('data-kp-video-bound', '1');
    video.removeAttribute('controls');
    video.setAttribute('playsinline', '');
    tile.classList.add('is-enhanced');
    tile.setAttribute('role', 'button');
    tile.setAttribute('tabindex', '0');
    label(tile, false);

    function toggle() {
      if (video.paused) {
        pauseOthers(video);
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () { /* autoplay policy: the next tap plays */ });
      } else {
        video.pause();
      }
    }

    tile.addEventListener('click', toggle);
    tile.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); }
    });
    video.addEventListener('play', function () { tile.classList.add('is-playing'); label(tile, true); });
    video.addEventListener('pause', function () { tile.classList.remove('is-playing'); label(tile, false); });
    video.addEventListener('ended', function () { tile.classList.remove('is-playing'); label(tile, false); });
  }

  function init() { tiles().forEach(enhance); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
